import { render, staticRenderFns } from "./AddempRight.vue?vue&type=template&id=21dac74d&scoped=true"
import script from "./AddempRight.vue?vue&type=script&lang=js"
export * from "./AddempRight.vue?vue&type=script&lang=js"
import style0 from "./AddempRight.vue?vue&type=style&index=0&id=21dac74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dac74d",
  null
  
)

export default component.exports